import { render, staticRenderFns } from "./TotalSalesSearch.vue?vue&type=template&id=c427b2d8&"
import script from "./TotalSalesSearch.vue?vue&type=script&lang=js&"
export * from "./TotalSalesSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports